import axios, { AxiosResponse } from 'axios';
import useUser from './useUser';

import { URL_MOVEMENT_IM } from 'constants/url';

export default function useMovementsIM() {
  const { jwt } = useUser();
  const headers = {
    Authorization: `Bearer ${jwt}`
  };

  const getInventoryEntries = (page: number, rowsPerPage: number, search: string): Promise<any> => {
    return axios
      .get(`${URL_MOVEMENT_IM}?pageSize=${rowsPerPage}&page=${page}&search=${search}`, { headers })
      .then((result: AxiosResponse) => {
        return result.data;
      });
  };
  const getProductById = (productId: string): Promise<any> => {
    return axios.get(`${URL_MOVEMENT_IM}/${productId}`, { headers }).then((result: AxiosResponse) => {
      if (result.status === 200) {
        return result.data;
      } else {
        return null;
      }
    });
  };

  const createMovement = (data: any): Promise<boolean> => {
    return axios.post(`${URL_MOVEMENT_IM}`, data, { headers }).then((response: AxiosResponse) => {
      return response.status === 201;
    });
  };

  return {
    getInventoryEntries,
    getProductById,
    createMovement
  };
}
